<div class="bary-table-list table-responsive">
  <table mdbTable [hover]="true" [small]="true">
    <thead>
      <tr [(ascending)]="pagination.reverse" [(predicate)]="pagination.predicate" (sortChange)="transition()" jhiSort>
        <th jhiSortBy="name">
          <span jhiTranslate="merchandises.list.name">Name</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th><span jhiTranslate="merchandises.list.offer">Offers</span></th>
        <th><span jhiTranslate="merchandises.list.forceQuotation">Force quotation</span></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let merchandise of sortByName(); let index = index">
        <td>
          <span class="no-capitalize">{{ merchandise.oldName }}</span>
        </td>
        <td>
          <ng-container *ngFor="let offer of merchandise.offers">
            <jhi-bary-badge [options]="{ color: PRIMARY_COLOR, label: offer.name }" [pill]="false"></jhi-bary-badge>
          </ng-container>
        </td>
        <td>
          <jhi-bary-input-switch
            [disabled]="false"
            [onLabel]="'sur devis'"
            *ngIf="merchandise.forceQuotation"
            [value]="true"
            (onChangeEvent)="changeActif($event, merchandise)"
          ></jhi-bary-input-switch>
          <jhi-bary-input-switch [disabled]="false" *ngIf="!merchandise.forceQuotation" [value]="false" (onChangeEvent)="changeActif($event, merchandise)"></jhi-bary-input-switch>
        </td>
        <td>
          <div class="d-flex justify-content-end">
            <jhi-bary-button
              [tooltip]="'entity.action.rename' | translate"
              size="sm"
              [floating]="true"
              [rounded]="true"
              [outline]="true"
              color="primary"
              (clickEvent)="rename(merchandise)"
              icon="pencil-alt"
            ></jhi-bary-button>
            <jhi-bary-button
              [tooltip]="'entity.action.attribute' | translate"
              size="sm"
              class="mx-3"
              [floating]="true"
              [outline]="true"
              [rounded]="true"
              color="primary"
              (clickEvent)="joinOffers(merchandise)"
              icon="clipboard-check"
            ></jhi-bary-button>

            <jhi-bary-button
              [tooltip]="'BTN.DELETE' | translate"
              size="sm"
              [floating]="true"
              [rounded]="true"
              color="primary"
              (clickEvent)="deleteMerchandise(merchandise)"
              icon="times"
            ></jhi-bary-button>
          </div>
        </td>
      </tr>
      <tr *ngIf="!isHidden()" class="text-center">
        <td colspan="7" class="table-data-not-found">
          <div class="text-center">
            <p class="lead p-5" jhiTranslate="LABEL.NO_RESULT">No Merchandises</p>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
